import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useNavScroll } from '../../hooks/useNavScroll';
import { useActiveNav } from '../../hooks/useActiveNav';
import HashLink from '../HashLink/HashLink';
import ArrowIcon from '../icons/ArrowIcon';

const NAV_ITEMS = [
  { label: 'Services', to: '/services' },
  { label: 'About', to: '/about' },
  { label: 'Industries', to: '/industries' },
  { label: 'Technologies', to: '/technologies' },
  { label: 'Work', hash: '#work' },
  { label: 'Contact', to: '/contact' },
];

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  useNavScroll(navRef);
  useActiveNav();

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  useEffect(() => {
    if (!menuOpen) return;
    const close = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    document.addEventListener('keydown', close);
    return () => document.removeEventListener('keydown', close);
  }, [menuOpen]);

  useEffect(() => {
    if (!menuOpen) return;
    const onOutside = (e) => {
      const links = document.getElementById('navLinks');
      const toggle = document.getElementById('navToggle');
      if (!links?.classList.contains('open')) return;
      if (links.contains(e.target) || toggle?.contains(e.target)) return;
      setMenuOpen(false);
    };
    document.addEventListener('click', onOutside);
    return () => document.removeEventListener('click', onOutside);
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  const goHome = (e) => {
    e.preventDefault();
    closeMenu();
    navigate('/');
    window.history.replaceState(null, '', '/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const isServices = location.pathname === '/services';
  const isAbout = location.pathname === '/about';
  const isIndustries = location.pathname === '/industries';
  const isTechnologies = location.pathname === '/technologies';
  const isContact = location.pathname === '/contact';

  return (
    <header className="nav" id="nav" ref={navRef}>
      <div className="nav-inner container">
        <Link to="/" className="nav-logo" aria-label="CodeInventiv Solutions home" onClick={goHome}>
          <img
            className="site-logo"
            src="/logos/01_primary_logo_dark-removebg-preview.png?v=5"
            alt="CodeInventiv Solutions"
            width="320"
            height="64"
            decoding="async"
          />
        </Link>

        <nav aria-label="Primary">
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`} id="navLinks">
            {NAV_ITEMS.map((item) => {
              const active =
                (item.to === '/services' && isServices) ||
                (item.to === '/about' && isAbout) ||
                (item.to === '/industries' && isIndustries) ||
                (item.to === '/technologies' && isTechnologies) ||
                (item.to === '/contact' && isContact);
              return (
                <li key={item.to || item.hash}>
                  {item.to ? (
                    <Link
                      to={item.to}
                      className={active ? 'active' : undefined}
                      onClick={closeMenu}
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <HashLink to={item.hash} onClick={closeMenu}>
                      {item.label}
                    </HashLink>
                  )}
                </li>
              );
            })}
          </ul>
        </nav>

        <div className="nav-actions">
          <Link to="/contact" className="btn btn-gold btn-sm" onClick={closeMenu}>
            Get a Quote
            <ArrowIcon size={14} />
          </Link>
          <button
            type="button"
            className="nav-toggle"
            id="navToggle"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={(e) => {
              e.stopPropagation();
              setMenuOpen((o) => !o);
            }}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
